import type { EventOverview } from '@mmef/shared/api';
import type { AppDispatch } from '@/app/store';
import { eventsApi } from './eventsApi';

/**
 * Loads the homepage overview the server embedded in the page, before React first renders.
 *
 * <p>The server already drew the homepage from these numbers. Starting React from the same copy
 * means its first render matches what is on screen; fetching them afresh would draw an empty page
 * first and blink the content away and back.
 *
 * <p>Absent on every other route, and on the static fallback page — then this does nothing and the
 * homepage fetches as normal. A malformed copy is treated the same way rather than breaking startup.
 */
export function seedOverview(dispatch: AppDispatch, doc: Document = document): void {
  const text = doc.getElementById('home-overview')?.textContent;
  if (!text) return;
  try {
    const overview = JSON.parse(text) as EventOverview;
    // upsertQueryEntries, not upsertQueryData: the latter runs as a query and settles a tick later,
    // after React's first render — which is exactly the blink this exists to prevent.
    dispatch(eventsApi.util.upsertQueryEntries([{ endpointName: 'getOverview', arg: undefined, value: overview }]));
  } catch {
    // Fall through to an ordinary fetch.
  }
}
